// extracted by mini-css-extract-plugin
export default {"content":"PageContent_content__bYZgT","button":"PageContent_button__QpvhU"};